import { LEARN_CARDS } from "./content";

const ef = (row, n) => Array.from({ length: n }, (_, i) => `/assets/platforms/ef-${row}${String(i).padStart(2, "0")}.webp`);
const upt = Array.from({ length: 19 }, (_, i) => `/assets/platforms/upt-${String(i).padStart(2, "0")}.webp`);
const POSTER = "w-[40vw] sm:w-[190px] lg:w-[210px] aspect-[300/580] rounded-[16px] ring-1 ring-white/10";

export const PLATFORMS = [
  {
    id: "espiritualflix",
    number: "01",
    name: "EspiritualFlix",
    logo: "/assets/platforms/ef-logo.png",
    banner: "/assets/platforms/ef-hero.webp",
    accent: "#c9a2ff",
    glow: "radial-gradient(closest-side, rgba(155,92,255,0.55), transparent)",
    description:
      "A maior plataforma de espiritualidade da Conexão Estelar: cursos profissionalizantes com certificado, formações terapêuticas, aulas ao vivo toda semana, palestras, podcasts e uma biblioteca completa de apostilas.",
    stats: [
      { value: "+1.000", label: "aulas" },
      { value: "+50", label: "cursos com certificado" },
      { value: "+100", label: "apostilas" },
      { value: "Formação", label: "profissional" },
    ],
    features: [
      "Trilha do Reiki",
      "Formações terapêuticas e espirituais",
      "Terapias naturais e bem-estar",
      "Aulas ao vivo toda semana",
      "Palestras e podcasts",
      "Biblioteca do Terapeuta",
      "Filmes recomendados",
    ],
    rows: [
      { title: "Cursos e formações", images: ef("a", 17), itemClass: POSTER },
      { title: "Aulas ao vivo, práticas e bem-estar", images: ef("b", 19), itemClass: POSTER },
    ],
  },
  {
    id: "umbanda-para-todos",
    number: "02",
    name: "Comunidade Umbanda para Todos",
    logo: "/assets/logo_umbanda_para_todos.webp",
    banner: "/assets/platforms/upt-banner.webp",
    accent: "#d9b45a",
    glow: "radial-gradient(closest-side, rgba(217,180,90,0.45), transparent)",
    description:
      "A comunidade do Sacerdote Edvilson: aulas de Umbanda, mediunidade e espiritualidade, apostilas, aulas ao vivo e mentoria em grupo — tudo também no aplicativo Hotmart, direto no seu celular.",
    stats: [
      { value: "+80", label: "aulas de +1 hora" },
      { value: "19", label: "trilhas de conteúdo" },
      { value: "Ao vivo", label: "toda semana" },
      { value: "App", label: "Hotmart no celular" },
    ],
    features: [
      "Cursos de Umbanda",
      "Mediunidade e sensitividade (2 módulos)",
      "Mentorias em grupo",
      "Aulas ao vivo",
      "Podcasts",
      "Jogo de cartas",
      "Eventos religiosos",
      "Ações e projetos sociais",
      "Grupo no WhatsApp",
    ],
    rows: [
      {
        title: "Trilhas da comunidade",
        images: upt,
        itemClass: "w-[44vw] sm:w-[220px] lg:w-[240px] aspect-[276/398] rounded-[16px] ring-1 ring-white/10",
      },
      {
        title: "Conteúdos em destaque",
        images: LEARN_CARDS,
        itemClass: "w-[40vw] sm:w-[190px] lg:w-[210px] aspect-[187/376] rounded-[18px] ring-1 ring-white/20",
      },
    ],
  },
];
